<template>
  <div class="news-list">
    <BasePage mode="list">
      <div slot="toolBar">
        <el-row>
          <div style="float: right">
            <OfSearch
              @search="search"
              style="float: left; padding-right: 5%"
              :placeholder="placeholder"
            ></OfSearch>
            <el-button size="small" icon="el-icon-search" type="danger" @click="loadData">查询</el-button>
          </div>
        </el-row>
      </div>

      <div>
        <el-table
          border
          hightlight-current-row
          style="width: 100%"
          :header-cell-class-name="headerRow"
          :data="listData"
          :max-height="tableMaxHeight()"
          v-loading="isloading"
        >
          <el-table-column
            prop="ExceptionMsg"
            label="异常信息"
            align="left"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="MethodName"
            label="方法名称"
            align="left"
            width="220"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="Source"
            label="来源"
            align="center"
            width="100"
          ></el-table-column>
          <el-table-column label="异常时间" align="center" width="140">
            <template slot-scope="scope">
              {{ (scope.row.ExceptionTime * 1000) | formatDate }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button
                v-access:read
                @click="innerRead(scope.row)"
                type="text"
                size="mini"
                >详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-wapper">
          <OfPagination
            :total="total"
            :pageSize="pageSize"
            :currentPage="currentPage"
            @onSizeChange="handleSizeChange"
            @onCurrentChange="handleCurrentChange"
          ></OfPagination>
        </div>
      </div>
    </BasePage>
    <ModuleEdit
      v-if="formVisible"
      :dataForm="formData"
      :formTitle="formTitle"
      :isEdit="isEdit"
      @formCallBack="formCallBack"
    ></ModuleEdit>
    <ModuleQuery
      v-if="formVisibleQuery"
      :dataForm="formDataQuery"
      :formTitle="formTitleQuery"
      @formCallBack="formCallBack"
    >
    </ModuleQuery>
  </div>
</template>

<script>
import BasePage from "@/components/base/of_page/of_page";
import OfSearch from "@/components/controls/of_search/of_search";
import ModuleQuery from "@/modules/zjrc/pages/log/ex/query";
import OfPagination from "@/components/controls/of_pagination/of_pagination";
import api from "@/modules/zjrc/api";

export default {
  name: "list",
  data() {
    return {
      isloading: false,
      listData: [],
      headerRow: "header-row",
      formVisible: false,
      formVisibleQuery: false,
      formTitle: "",
      formTitleQuery: "",
      formData: {},
      formDataQuery: {},
      total: 0,
      currentPage: 1,
      pageSize: 15,
      placeholder: "方法名称 / 来源 ",
      searchKey: "",
      isEdit: true,
    };
  },
  methods: {
    loadData() {
      this.isloading = true;
      let params = {
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        SearchKey: this.searchKey,
      };
      api.QueryExLog(params).then((rep) => {
        if (rep.data.Code === 0) {
          this.total = rep.data.Data.total;
          this.listData = rep.data.Data.rows;
        }
        this.isloading = false;
      });
    },
    innerRead(rowData) {
      this.formTitleQuery = "日志信息";
      this.formDataQuery = Object.assign({}, rowData);
      this.formVisibleQuery = true;
    },
    formCallBack(data) {
      this.formVisible = false;
      this.formVisibleQuery = false;
      if (data != null) {
        this.loadData();
      }
    },

    formCallBackQuery() {
      this.formVisibleQuery = false;
    },

    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.loadData();
    },
    handleCurrentChange(val) {
      if (this.total > this.pageSize) {
        this.currentPage = val;
        this.loadData();
      }
    },
    tableMaxHeight() {
      var clientHeight = window.innerHeight;
      var tableMaxHeight = 0;
      if (clientHeight && clientHeight !== undefined) {
        tableMaxHeight = clientHeight - 363;
      }
      return tableMaxHeight;
    },
    //搜索
    btnSearch() {
      this.loadData();
    },
    //关键字搜索
    search(keyword) {
      this.searchKey = keyword;
      this.loadData()
    },
  },
  components: {
    BasePage,
    OfSearch,
    OfPagination,
    ModuleQuery,
  },
  mounted() {
    this.loadData();
  },
  computed: {
    isEnable: function () {
      return (rowData) => {
        return rowData.Status == 1 ? false : true;
      };
    },
  },
};
</script>

<style scoped>
.el-select >>> .el-input__inner {
  width: 2.5rem;
}
</style>
